import { Children, Component, createElement } from 'react';
import invariant from '../tiny-invariant';
import warning from '../tiny-warning';
import RouterContext from './RouterContext';
import matchPath from './matchPath';

/** @deprecated StaticRouter has been removed; this type is retained for API compatibility only. */
import { jsx as _jsx } from "react/jsx-runtime";
function isEmptyChildren(children) {
  return Children.count(children) === 0;
}
function evalChildrenDev(children, props, path) {
  const value = children(props);
  warning(value !== undefined, 'You returned `undefined` from the `children` function of ' + `<Route${path ? ` path="${path}"` : ''}>, but you ` + 'should have returned a React element or `null`');
  return value || null;
}

/**
 * The public API for matching a single path and rendering.
 */
class Route extends Component {
  render() {
    return /*#__PURE__*/_jsx(RouterContext.Consumer, {
      children: context => {
        invariant(context, 'You should not use <Route> outside a <Router>');
        const location = this.props.location || context.location;
        // @ts-ignore computedMatch is injected by Switch via cloneElement, not part of public RouteProps
        const routeMatch = this.props.computedMatch ?
        // @ts-ignore computedMatch injected by Switch
        this.props.computedMatch : this.props.path ? matchPath(location.pathname, this.props) : context.match;
        const props = Object.assign({}, context, {
          location,
          match: routeMatch
        });
        let {
          children
        } = this.props;
        const {
          component,
          render
        } = this.props;

        // Preact uses an empty array as children by
        // default, so use null if that's the case.
        if (Array.isArray(children) && children.length === 0) {
          children = null;
        }
        return /*#__PURE__*/_jsx(RouterContext.Provider, {
          value: props,
          children: props.match ? children ? typeof children === 'function' ? process.env.NODE_ENV !== 'production' ? evalChildrenDev(children, props, this.props.path) : children(props) : children : component ? /*#__PURE__*/createElement(component, props) : render ? render(props) : null : typeof children === 'function' ? process.env.NODE_ENV !== 'production' ? evalChildrenDev(children, props, this.props.path) : children(props) : null
        });
      }
    });
  }
  componentDidMount() {
    if (process.env.NODE_ENV !== 'production') {
      warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), 'You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored');
      warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), 'You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored');
      warning(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');
    }
  }
  componentDidUpdate(prevProps) {
    if (process.env.NODE_ENV !== 'production') {
      warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
      warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    }
  }
}
export default Route;